/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:14:53
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-29 10:02:45
 * @FilePath: \newsmartmapout\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isOpenStation: false,
    openStr:[],
    isLogon:false,
  },
  getters: {
  },
  mutations: {
    setOpenstatdata(state,data){
      state.isOpenStation = data
    },
    setisLogon(state,data){
      state.isLogon = data
    },
    setopenStr(state,data){
      state.openStr = data
    }
  },
  actions: {
  },
  modules: {
  }
})
